// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__H5U5o","balanceDisclaimer":"posDashboard_balanceDisclaimer__3AC6i"};